enum SlotTypes {
  public = 'Public',
  reserved = 'Reserved',
  urgent = 'Urgent',
}

export type SlotTypeName = keyof typeof SlotTypes

export const mediums = Object.keys(SlotTypes) as SlotTypeName[]

export default SlotTypes
